module.exports = __webpack_public_path__ + "static/media/awing.36fb2e91.png";